// eslint-disable-next-line import/no-cycle
import { DataService } from '../../../config/dataService/dataService';

export const updateProfileApi = (data) => {
  const formData = new FormData();
  // Payload keys matching API expectation (email excluded - read-only)
  if (data?.colour != null) formData.append('colour', data.colour);
  if (data?.business_category_id != null) formData.append('business_category_id', data.business_category_id);
  if (data?.first_name != null) formData.append('first_name', data.first_name);
  if (data?.last_name != null) formData.append('last_name', data.last_name);
  if (data?.slug != null) formData.append('slug', data.slug);
  if (data?.company_name != null) formData.append('company_name', data.company_name);
  if (data?.mobile_number != null) formData.append('mobile_number', data.mobile_number);
  if (data?.vat_number != null) formData.append('vat_number', data.vat_number);
  if (data?.ateco_code != null) formData.append('ateco_code', data.ateco_code);
  if (data?.cf_code != null) formData.append('cf_code', data.cf_code);
  if (data?.full_registered_address != null) formData.append('full_registered_address', data.full_registered_address);
  if (data?.full_registered_address_details != null) {
    formData.append('full_registered_address_details', JSON.stringify(data.full_registered_address_details));
  }
  if (data?.shipping_address != null) formData.append('shipping_address', data.shipping_address);
  if (data?.shipping_address_details != null) {
    formData.append('shipping_address_details', JSON.stringify(data.shipping_address_details));
  }
  if (data?.pec != null) formData.append('pec', data.pec);
  if (data?.sdi_code != null) formData.append('sdi_code', data.sdi_code);
  if (data?.intended_product_services != null)
    formData.append('intended_product_services', data.intended_product_services);
  if (data?.annual_revenue != null) formData.append('annual_revenue', data.annual_revenue);
  if (data?.google_my_business_name != null) {
    formData.append('google_my_business_name', data.google_my_business_name);
  }
  const logoFile = data?.imageName?.file?.originFileObj || data.logo;
  if (logoFile != null) formData.append('logo', logoFile);

  return DataService.post('/merchant/update-business-detail', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};
